import React from "react";
import { useLang } from "../lib/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-neutral-200 mt-24" data-testid="site-footer">
      <div className="fd-container py-12 md:py-16 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 bg-neutral-900 flex items-center justify-center">
              <span className="text-white text-sm font-semibold">F</span>
            </div>
            <span className="text-lg font-medium">Friend Doors</span>
          </div>
          <p className="text-sm text-neutral-500 max-w-sm leading-relaxed">{t("footer.tagline")}</p>
        </div>
        <div className="md:col-span-3">
          <p className="fd-label mb-3">Contact</p>
          <p className="text-sm text-neutral-700">Bakı, Azərbaycan</p>
          <p className="text-sm text-neutral-700">+994 50 000 00 00</p>
          <p className="text-sm text-neutral-700">info@frienddoors.az</p>
        </div>
        <div className="md:col-span-4 flex md:justify-end items-end">
          <p className="text-xs text-neutral-400">© {new Date().getFullYear()} Friend Doors. {t("footer.rights")}.</p>
        </div>
      </div>
    </footer>
  );
}
